import { useLayoutEffect, useRef, useState } from "react";

// Renders `children` inside a fixed virtual viewport (width x height) and scales
// it down to fit the available width, so a full page can be previewed inline.
export default function ScaledPreview({ width, height, maxScale = 1, className = "", children }) {
    const containerRef = useRef(null);
    const [scale, setScale] = useState(0);

    useLayoutEffect(() => {
        const el = containerRef.current;
        if (!el) return;

        const update = () => setScale(Math.min(maxScale, el.clientWidth / width));
        update();

        if (typeof ResizeObserver === "undefined") return;
        const observer = new ResizeObserver(update);
        observer.observe(el);
        return () => observer.disconnect();
    }, [width, maxScale]);

    return (
        <div ref={containerRef} className="w-full">
            <div
                className={`mx-auto overflow-hidden ${className}`}
                style={{ width: width * scale, height: height * scale }}
            >
                <div style={{ width, height, transform: `scale(${scale})`, transformOrigin: "top left" }}>
                    {children}
                </div>
            </div>
        </div>
    );
}
